var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"child-layout"},[_c('header-menu',[_c('router-view',{attrs:{"name":"sidebar"}})],1),_c('div',{staticClass:"content"},[_c('router-view',{staticClass:"sub-content"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }